import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

const NormalText = ({ text }: { text: string }) => {
  return (
    <Text.Normal color="grey1000" size="200" weight="medium">
      {text}
    </Text.Normal>
  )
}

export default NormalText
